import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import EllipsisMenu  from 'app/components/common/ellipsis-menu';
import Icon          from 'app/components/common/icon';
import SortableList  from 'app/components/common/sortable-list';
import StandardInput from 'app/components/common/standard-input';



class TagListInputItem extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isEdit: false,
      inputStr: '',
    };

    this.refInput = React.createRef();

    this.onClickEdit = this.onClickEdit.bind(this);
    this.onClickDelete = this.onClickDelete.bind(this);
    this.onClickDone = this.onClickDone.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onKeyPressInput = this.onKeyPressInput.bind(this);
    this.onBlurInput = this.onBlurInput.bind(this);
  }
  onClickEdit(event) {
    event?.preventDefault && event?.preventDefault();
    this.setState({isEdit: true, inputStr: this.props.item}, () => {
      setTimeout(() => {
        this.refInput.current.element?.focus();
      }, 50);
    });
  }
  onClickDelete(event) {
    event?.preventDefault && event?.preventDefault();
    this.props.onDelete(this.props.index);
  }
  onClickDone() {
    this.commit();
  }
  onChange(event) {
    const inputStr = event.target.value;
    this.setState({inputStr});
  }
  onKeyPressInput(event) {
    const isEnter = event.key === 'Enter';
    if (!isEnter) return;
    this.commit();
  }
  onBlurInput(event) {
    setTimeout(() => {
      this.setState({isEdit: false});
    }, 0)
  }
  commit() {
    this.setState({isEdit: false});
    const item = (this.state.inputStr || '').trim();
    if (!item) return;
    this.props.onChange(this.props.index, this.state.inputStr);
  }
  render() {
    const {handleEl, item} = this.props;
    const {isEdit, inputStr} = this.state;
    return (
      <>
        {handleEl}
        {isEdit ? (<>
          <StandardInput ref={this.refInput} value={inputStr} onChange={this.onChange} onKeyPress={this.onKeyPressInput} onBlur={this.onBlurInput} label="Title" name="title" className="taglist-item-input xs" />
          <button className="btn xs secondary blue ghost" onClick={this.onClickDone}>done</button>
        </>) : (<>
          <div className="taglist-item-tag-con" onClick={this.onClickEdit}>
            <div className="taglist-item-tag">{item}</div>
          </div>
          <EllipsisMenu usePortal className="alt1">
            <a href="#" onClick={this.onClickEdit}><Icon.Pencil /> Edit</a>
            <a href="#" onClick={this.onClickDelete}><Icon.Bin /> Delete</a>
          </EllipsisMenu>
        </>)}
      </>
    );
  }
}
TagListInputItem.propTypes = {
  item: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
  handleEl: PropTypes.node.isRequired,
};



class TagListInput extends React.PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      showAdd: false,
      addInputStr: '',
    };

    this.refAddInput = React.createRef();

    this.onSort = this.onSort.bind(this);
    this.renderItem = this.renderItem.bind(this);
    this.onChangeItem = this.onChangeItem.bind(this);
    this.onDeleteItem = this.onDeleteItem.bind(this);
    this.onClickShowAdd = this.onClickShowAdd.bind(this);
    this.onChangeAddInput = this.onChangeAddInput.bind(this);
    this.onKeyPressAddInput = this.onKeyPressAddInput.bind(this);
    this.onBlurAddInput = this.onBlurAddInput.bind(this);
  }

  onSort(items) {
    this.props.onChange(items);
  }

  onChangeItem(index, item) {
    const items = [...this.props.items];
    items[index] = item;
    this.commit(items);
  }

  onDeleteItem(index) {
    const items = [...this.props.items];
    items.splice(index, 1);
    this.commit(items);
  }

  onChangeAddInput(event) {
    const addInputStr = event.target.value;
    this.setState({addInputStr});
  }
  onBlurAddInput(event) {
    if (!event.target.value) {
      this.setState({addInputStr: '', showAdd: false});
    }
  }
  onKeyPressAddInput(event) {
    const isEnter = event.key === 'Enter';
    if (isEnter) {
      this.addItem(this.state.addInputStr);
      this.setState({addInputStr: ''});
    }
  }
  onClickShowAdd(event) {
    event?.preventDefault && event.preventDefault();
    this.setState({showAdd: true, addInputStr: ''}, () => {
      this.refAddInput?.current?.element?.focus();
    });
  }

  addItem(dirtyItem) {
    const cleanItem = (dirtyItem || '').trim();
    if (!cleanItem) return;
    const items = [cleanItem, ...this.props.items];
    this.commit(items);
  }

  commit(items) {
    // trim whitespace, remove dupes, remove emtpies
    let sanitized = [...new Set(items.map(i => (i || '').trim()).filter(i => i))];
    // also do a case-insensitive dupe removal
    const uppers = {};
    sanitized = sanitized.filter((item) => {
      const upper = item.toUpperCase();
      if (uppers[upper]) return false;
      uppers[upper] = true;
      return true;
    });
    this.props.onChange(sanitized);
  }

  renderItem(item, index, dnd) {
    return (
      <div className={`taglist-item ${dnd.className}`}>
        <TagListInputItem item={item} index={index} handleEl={dnd.handleEl} onChange={this.onChangeItem} onDelete={this.onDeleteItem} />
      </div>
    );
  }

  render() {
    const {items, className} = this.props;
    const {showAdd, addInputStr} = this.state;
    const hasItems = !!items.length;

    return (
      <div className={`taglist ${className}`}>
        <StandardInput label="Type a new option..." name="item" value={addInputStr} onChange={this.onChangeAddInput} onKeyPress={this.onKeyPressAddInput} onBlur={this.onBlurAddInput} className="small taglist-add-input" ref={this.refAddInput} />
        {hasItems ? (<>
          <div className={`taglist-list`}>
            <SortableList items={items} onSort={this.onSort} renderItem={this.renderItem} distinctHandle />
          </div>
        </>) : (<>
          <p className="taglist-empty">No options added yet.</p>
        </>)}
      </div>
    );
  }

}

TagListInput.propTypes = {
  items: PropTypes.arrayOf(PropTypes.string).isRequired,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
};
TagListInput.defaultProps = {
  className: '',
};

export default TagListInput;
